import { Pipe } from "@angular/core";
import { serializer } from "./safe.util";
export var SafeJsonPipe = (function () {
    function SafeJsonPipe() {
    }
    SafeJsonPipe.prototype.transform = function (obj, spaces) {
        if (spaces === void 0) { spaces = 2; }
        return JSON.stringify(obj, serializer(), spaces);
    };
    SafeJsonPipe.decorators = [
        { type: Pipe, args: [{
                    name: "json",
                    pure: false
                },] },
    ];
    /** @nocollapse */
    SafeJsonPipe.ctorParameters = function () { return []; };
    return SafeJsonPipe;
}());
//# sourceMappingURL=json.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-prettyjson/src/json.pipe.js
// module id = 138
// module chunks = 10